neo.socketio = {
	open_tasks: {},
	open_docs: [],
	emit_queue: [],
	init: function(port = 3000) {
		if (!window.io) {
			return;
		}

		if (neo.boot.disable_async) {
			return;
		}

		if (neo.socketio.socket) {
			return;
		}

		//Enable secure option when using HTTPS
		if (window.location.protocol == "https:") {
			neo.socketio.socket = io.connect(neo.socketio.get_host(port), {secure: true});
		}
		else if (window.location.protocol == "http:") {
			neo.socketio.socket = io.connect(neo.socketio.get_host(port));
		}
		else if (window.location.protocol == "file:") {
			neo.socketio.socket = io.connect(window.localStorage.server);
		}

		if (!neo.socketio.socket) {
			console.log("Unable to connect to " + neo.socketio.get_host(port));
			return;
		}

		neo.socketio.socket.on('msgprint', function(message) {
			neo.msgprint(message);
		});

		neo.socketio.socket.on('eval_js', function(message) {
			eval(message);
		});

		neo.socketio.socket.on('progress', function(data) {
			if(data.progress) {
				data.percent = flt(data.progress[0]) / data.progress[1] * 100;
			}
			if(data.percent) {
				if(data.percent==100) {
					neo.hide_progress();
				} else {
					neo.show_progress(data.title || __("Progress"), data.percent, 100, data.description);
				}
			}
		});

		neo.socketio.setup_listeners();
		neo.socketio.setup_reconnect();

		$(document).on('form-load form-rename', function(e, frm) {
			if (frm.is_new()) {
				return;
			}

			for (var i=0, l=neo.socketio.open_docs.length; i<l; i++) {
				var d = neo.socketio.open_docs[i];
				if (frm.doctype==d.doctype && frm.docname==d.name) {
					// already subscribed
					return false;
				}
			}

			neo.socketio.doc_subscribe(frm.doctype, frm.docname);
		});

		$(document).on("form-refresh", function(e, frm) {
			if (frm.is_new()) {
				return;
			}

			neo.socketio.doc_open(frm.doctype, frm.docname);
		});

		$(document).on('form-unload', function(e, frm) {
			if (frm.is_new()) {
				return;
			}

			// neo.socketio.doc_unsubscribe(frm.doctype, frm.docname);
			neo.socketio.doc_close(frm.doctype, frm.docname);
		});

		$(document).on('form-typing', function(e, frm) {
			neo.socketio.form_typing(frm.doctype, frm.docname);
		});

		$(document).on('form-stopped-typing', function(e, frm) {
			neo.socketio.form_stopped_typing(frm.doctype, frm.docname);
		});

		window.addEventListener('beforeunload', () => {
			if (!cur_frm || cur_frm.is_new()) {
				return;
			}

			// if tab/window is closed, notify other users
			if (cur_frm.doc) {
				neo.socketio.doc_close(cur_frm.doctype, cur_frm.docname);
			}
		});
	},
	get_host: function(port = 3000) {
		var host = window.location.origin;
		if(window.dev_server) {
			var parts = host.split(":");
			port = neo.boot.socketio_port || port.toString() || '3000';
			if(parts.length > 2) {
				host = parts[0] + ":" + parts[1];
			}
			host = host + ":" + port;
		}
		return host;
	},
	subscribe: function(task_id, opts) {
		// TODO DEPRECATE

		neo.socketio.socket.emit('task_subscribe', task_id);
		neo.socketio.socket.emit('progress_subscribe', task_id);

		neo.socketio.open_tasks[task_id] = opts;
	},
	task_subscribe: function(task_id) {
		neo.socketio.socket.emit('task_subscribe', task_id);
	},
	task_unsubscribe: function(task_id) {
		neo.socketio.socket.emit('task_unsubscribe', task_id);
	},
	doc_subscribe: function(doctype, docname) {
		if (neo.flags.doc_subscribe) {
			console.log('throttled');
			return;
		}

		neo.flags.doc_subscribe = true;

		// throttle to 1 per sec
		setTimeout(function() { neo.flags.doc_subscribe = false }, 1000);

		neo.socketio.socket.emit('doc_subscribe', doctype, docname);
		neo.socketio.open_docs.push({doctype: doctype, docname: docname});
	},
	doc_unsubscribe: function(doctype, docname) {
		neo.socketio.socket.emit('doc_unsubscribe', doctype, docname);
		neo.socketio.open_docs = $.filter(neo.socketio.open_docs, function(d) {
			if(d.doctype===doctype && d.name===docname) {
				return null;
			} else {
				return d;
			}
		})
	},
	doc_open: function(doctype, docname) {
		// notify that the user has opened this doc, if not already notified
		if (!neo.socketio.last_doc
			|| (neo.socketio.last_doc[0] != doctype || neo.socketio.last_doc[1] != docname)) {
			neo.socketio.socket.emit('doc_open', doctype, docname);

			neo.socketio.last_doc &&
				neo.socketio.doc_close(neo.socketio.last_doc[0], neo.socketio.last_doc[1]);
		}
		neo.socketio.last_doc = [doctype, docname];
	},
	doc_close: function(doctype, docname) {
		// notify that the user has closed this doc
		neo.socketio.socket.emit('doc_close', doctype, docname);

		// if the doc is closed the user has also stopped typing
		neo.socketio.socket.emit('doc_typing_stopped', doctype, docname);
	},
	form_typing: function(doctype, docname) {
		// notifiy that the user is typing on the doc
		neo.socketio.socket.emit('doc_typing', doctype, docname);
	},
	form_stopped_typing: function(doctype, docname) {
		// notifiy that the user has stopped typing
		neo.socketio.socket.emit('doc_typing_stopped', doctype, docname);
	},
	setup_listeners: function() {
		neo.socketio.socket.on('task_status_change', function(data) {
			neo.socketio.process_response(data, data.status.toLowerCase());
		});
		neo.socketio.socket.on('task_progress', function(data) {
			neo.socketio.process_response(data, "progress");
		});
	},
	setup_reconnect: function() {
		// subscribe again to open_tasks
		neo.socketio.socket.on("connect", function() {
			// wait for 5 seconds before subscribing again
			// because it takes more time to start python server than nodejs server
			// and we use validation requests to python server for subscribing
			setTimeout(function() {
				$.each(neo.socketio.open_tasks, function(task_id, opts) {
					neo.socketio.subscribe(task_id, opts);
				});

				// re-connect open docs
				$.each(neo.socketio.open_docs, function(d) {
					if(locals[d.doctype] && locals[d.doctype][d.name]) {
						neo.socketio.doc_subscribe(d.doctype, d.name);
					}
				});

				if (cur_frm && cur_frm.doc) {
					neo.socketio.doc_open(cur_frm.doc.doctype, cur_frm.doc.name);
				}
			}, 5000);
		});
	},
	process_response: function(data, method) {
		if(!data) {
			return;
		}

		// success
		var opts = neo.socketio.open_tasks[data.task_id];
		if(opts[method]) {
			opts[method](data);
		}

		// "callback" is std neo term
		if(method==="success") {
			if(opts.callback) opts.callback(data);
		}

		// always
		neo.request.cleanup(opts, data);
		if(opts.always) {
			opts.always(data);
		}

		// error
		if(data.status_code && data.status_code > 400 && opts.error) {
			opts.error(data);
		}
	}
}

neo.provide("neo.realtime");
neo.realtime.on = function(event, callback) {
	neo.socketio.socket && neo.socketio.socket.on(event, callback);
};

neo.realtime.off = function(event, callback) {
	neo.socketio.socket && neo.socketio.socket.off(event, callback);
}

neo.realtime.publish = function(event, message) {
	if(neo.socketio.socket) {
		neo.socketio.socket.emit(event, message);
	}
}

